import React from 'react';
import { Initials, AvatarContainer, AvatarImage } from './index.styles';

const Avatar = ({ bgColor, handleClick, user }) => {
	const { FullName, ImageUrl } = user;
	const initials = FullName.split(' ').map((x) => x.charAt(0)).join('');
	return (
		<AvatarContainer onClick={handleClick}>
			{' '}
			{!ImageUrl ? (
				<Initials className={`bg-${bgColor}-400`}>{initials}</Initials>
			) : (
				<AvatarImage src={'https://bndbs.ir/'+ ImageUrl} alt={initials} />
			)}
		</AvatarContainer>
	);
};

export default Avatar;
